<template>
  <h1 class="content-title">{{ title }}</h1>
</template>

<script>
	export default {
    computed : {},
    props: {
      title: String,
      color: String,
    }
	}
</script>

<style lang="scss" scoped>
@import "@/style/base.scss";
@import "@/style/helpers/typography.scss";

.content-title {
  font-size: 30px;
  text-transform: uppercase;
  margin-bottom: 20px;
}
</style>
